import React from "react";

const Dark = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" data-setthemeto="Dark">
      <path
        d="M34.5 17.5C34.5 26.8888 26.8888 34.5 17.5 34.5C8.11116 34.5 0.5 26.8888 0.5 17.5C0.5 8.11113 8.11116 0.499969 17.5 0.499969C26.8888 0.499969 34.5 8.11113 34.5 17.5Z"
        data-setthemeto="Dark"
        stroke="#282C34"
      />
      <path
        d="M33.9243 18.4239C33.9243 26.7203 26.7867 33.964 17.9587 33.964C7.5 33.964 0.924294 25.6843 0.924286 17.3878C0.924286 9.09134 13.5 24 16.393 17.3878C19.4868 4.95572 35 2.99997 33.9243 18.4239Z"
        data-setthemeto="Dark"
        fill="#282C34"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export default Dark;
